/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

//by importing everything here typescript will enforce uniqueness
//consider re-exporting

import * as TicketActionBuilders from '../state/ticket-action-builders';
import { CombinedTicketActions } from '../actions/ticket-actions';

import { PlanState } from 'src/app/services/plan-state.service';

export interface AllThePlanActions {
	changeTicketViewToEdit: typeof TicketActionBuilders.changeTicketViewToEdit;
	changeTicketViewToDrag: typeof TicketActionBuilders.changeTicketViewToDrag;
	changeTicketViewToDefault: typeof TicketActionBuilders.changeTicketViewToDefault;
	changeTicketViewToLocationsEdit: typeof TicketActionBuilders.changeTicketViewToLocationsEdit;
	changeTicketViewDataToDefault: typeof TicketActionBuilders.changeTicketViewDataToDefault;
	ticketDragged: typeof TicketActionBuilders.ticketDragged;
	abortEdit: typeof TicketActionBuilders.abortEdit;
	updateTicketLiveData: typeof TicketActionBuilders.updateTicketLiveData;
	updateTicketEditData: typeof TicketActionBuilders.updateTicketEditData;
	persistTicketData: typeof TicketActionBuilders.persistTicketData;
	persistTicketDataLocalOnly: typeof TicketActionBuilders.persistTicketDataLocalOnly;
	selectTicket: typeof TicketActionBuilders.selectTicket;
	selectCycleTicket: typeof TicketActionBuilders.selectCycleTicket;
	unSelectTicket: typeof TicketActionBuilders.unSelectTicket;
	unselectCycleTicket: typeof TicketActionBuilders.unselectCycleTicket;
	clearSelection: typeof TicketActionBuilders.clearSelection;
	focusTicket: typeof TicketActionBuilders.focusTicket;
	selectTicketToggle: typeof TicketActionBuilders.selectTicketToggle;
	selectTicketDelayed: typeof TicketActionBuilders.selectTicketDelayed;
	addFloatingTicketToPlan: typeof TicketActionBuilders.addFloatingTicketToPlan;
	moveTicketToFloating: typeof TicketActionBuilders.moveTicketToFloating;
	returnTicketToPlan: typeof TicketActionBuilders.returnTicketToPlan;
	saveFloatingTicketToPlan: typeof TicketActionBuilders.saveFloatingTicketToPlan;
	saveTicketToFloating: typeof TicketActionBuilders.saveTicketToFloating;
	deleteTicket: typeof TicketActionBuilders.deleteTicket;
	internalDeleteTicket: typeof TicketActionBuilders.internalDeleteTicket;
	duplicateTicket: typeof TicketActionBuilders.duplicateTicket;
	removeFloatingTickets: typeof TicketActionBuilders.removeFloatingTickets;
	simpleDependencyToggle: typeof TicketActionBuilders.simpleDependencyToggle;
	createTicketWithId: typeof TicketActionBuilders.createTicketWithId;
	addTicket: typeof TicketActionBuilders.addTicket;
	addPinToTicket: typeof TicketActionBuilders.addPinToTicket;
	removePinFromTicket: typeof TicketActionBuilders.removePinFromTicket;
}

export enum PlanActionTypes {
	other = 'other',
}
export interface OtherAction {
	type: PlanActionTypes.other;
}

export type CombinedPlanActions = CombinedTicketActions | OtherAction;

//takes all the actions and explicitly sets them to a passed in object, self is bound to
// another this you specify
export const applyScopedActions = function applyScopedActions(target: AllThePlanActions, self: PlanState) {
	target.changeTicketViewToEdit = TicketActionBuilders.changeTicketViewToEdit.bind(self);
	target.changeTicketViewToDrag = TicketActionBuilders.changeTicketViewToDrag.bind(self);
	target.changeTicketViewToDefault = TicketActionBuilders.changeTicketViewToDefault.bind(self);
	target.changeTicketViewToLocationsEdit = TicketActionBuilders.changeTicketViewToLocationsEdit.bind(self);
	target.changeTicketViewDataToDefault = TicketActionBuilders.changeTicketViewDataToDefault.bind(self);
	target.ticketDragged = TicketActionBuilders.ticketDragged.bind(self);
	target.abortEdit = TicketActionBuilders.abortEdit.bind(self);
	target.updateTicketLiveData = TicketActionBuilders.updateTicketLiveData.bind(self);
	target.updateTicketEditData = TicketActionBuilders.updateTicketEditData.bind(self);
	target.persistTicketData = TicketActionBuilders.persistTicketData.bind(self);
	target.persistTicketDataLocalOnly = TicketActionBuilders.persistTicketDataLocalOnly.bind(self);
	target.selectTicket = TicketActionBuilders.selectTicket.bind(self);
	target.selectCycleTicket = TicketActionBuilders.selectCycleTicket.bind(self);
	target.unSelectTicket = TicketActionBuilders.unSelectTicket.bind(self);
	target.unselectCycleTicket = TicketActionBuilders.unselectCycleTicket.bind(self);
	target.clearSelection = TicketActionBuilders.clearSelection.bind(self);
	target.selectTicketDelayed = TicketActionBuilders.selectTicketDelayed.bind(self);
	target.focusTicket = TicketActionBuilders.focusTicket.bind(self);
	target.selectTicketToggle = TicketActionBuilders.selectTicketToggle.bind(self);
	target.addFloatingTicketToPlan = TicketActionBuilders.addFloatingTicketToPlan.bind(self);
	target.moveTicketToFloating = TicketActionBuilders.moveTicketToFloating.bind(self);
	target.returnTicketToPlan = TicketActionBuilders.returnTicketToPlan.bind(self);
	target.saveFloatingTicketToPlan = TicketActionBuilders.saveFloatingTicketToPlan.bind(self);
	target.saveTicketToFloating = TicketActionBuilders.saveTicketToFloating.bind(self);
	target.deleteTicket = TicketActionBuilders.deleteTicket.bind(self);
	target.internalDeleteTicket = TicketActionBuilders.internalDeleteTicket.bind(self);
	target.duplicateTicket = TicketActionBuilders.duplicateTicket.bind(self);
	target.removeFloatingTickets = TicketActionBuilders.removeFloatingTickets.bind(self);
	target.simpleDependencyToggle = TicketActionBuilders.simpleDependencyToggle.bind(self);
	target.createTicketWithId = TicketActionBuilders.createTicketWithId.bind(self);
	target.addTicket = TicketActionBuilders.addTicket.bind(self);
	target.addPinToTicket = TicketActionBuilders.addPinToTicket.bind(self);
	target.removePinFromTicket = TicketActionBuilders.removePinFromTicket.bind(self);
};
